/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, Renderer2, ApplicationRef, OnInit, AfterViewInit, AfterContentInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MatDrawer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { IStepOption, TourService } from 'ngx-ui-tour-md-menu';
import { steps } from './tour-steps';
// import { TawkMessengerAngular } from '@tawk.to/tawk-messenger-angular';
// import { TawkComponent } from "./_components/tawk/tawk.component";

import { AngularFireAuth } from '@angular/fire/compat/auth';

import { AppService } from './_services/app.service';
import { LazyDialogService } from './_services/lazy-dialog.service';
import { FirestoreDbService } from './_services/firestore-db.service';
import { SidenavComponent } from './_components/sidenav.component';
import { CheckForUpdateService } from './_services/check-for-update.service';
import { SubscriptionsManager } from './_services/subscriptions-manager.service';
import { TimeoutsManager } from './_services/timeouts-manager.service';
import { ArtifactVerificationOptions_TlogIntegratedTimestampOptions } from '@sigstore/protobuf-specs/dist';
import { AnalyticsService } from './_services/analytics.service';

declare global {
  interface Window {
    Tawk_API: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {

  title = 'nvio';
  clients: any[] = [];
  campaigns: any[] = [];
  lists: any[] = [];
  flows: any[] = [];
  profiles: any[] = [];
  templates: any[] = [];
  user: any = {};
  @ViewChild('drawer')
  drawer!: MatDrawer;
  @ViewChild('sidenav')
  sidenav!: SidenavComponent;
  dataSubscription!: Subscription;
  isDark = false;
  theme = localStorage.getItem('theme') || 'light';
  deviceType = 'desktop';

  dateRangeForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    selectedDays: new FormControl(30),
  });
  datesOptions = [
    {
      label: 'Últimas 24h',
      value: 1,
    },
    {
      label: 'Última semana',
      value: 7,
    },
    {
      label: 'Últimos 30 días',
      value: 30
    },
    {
      label: 'Últimos 60 días',
      value: 60
    },
    {
      label: 'Últimos 90 días',
      value: 90
    },
    // {
    //   label: 'Último trimestre',
    //   value: 90
    // },
    {
      label: 'Rango personalizado',
      value: 0
    }
  ];
  moreDatesOptions = [
    {
      label: 'Últimas 24h',
      value: 1,
    },
    {
      label: 'Última semana',
      value: 7,
    },
    {
      label: 'Dos últimas semanas',
      value: 14,
    },
    {
      label: 'Últimos 30 días',
      value: 30
    },
    // {
    //   label: 'Último trimestre',
    //   value: 90
    // },
    {
      label: 'Rango personalizado',
      value: 0
    }
  ];
  selectedDays = 7;
  lastCustomRange: any = false;

  isExpanded = false;
  tawk: any;
  dateRange: any = {};

  steps: any[] = steps;

  blurred = false;
  subscriptions = new SubscriptionsManager();
  timeouts = new TimeoutsManager();

  private midnightTimeout: any;
  private dailyInterval: any;
  private readonly MS_PER_DAY = 24 * 60 * 60 * 1000;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AngularFireAuth,
    public appSvc: AppService,
    private lazyDialogSvc: LazyDialogService,
    private dbSvc: FirestoreDbService,
    private responsive: BreakpointObserver,
    private appRef: ApplicationRef,
    // public tawk: TawkMessengerAngular,
    private renderer: Renderer2,
    private _adapter: DateAdapter<any>,
    private checkForUpdate: CheckForUpdateService,
    private tourSvc: TourService,
    private analytics: AnalyticsService,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.myConstructor();
  }

  myConstructor() {

    // this.subscriptions.add(
    //   this.appRef.isStable.subscribe((res: any) => {
    //   })
    // );

    this.scheduleMidnightCheck();

    this.route.queryParams.subscribe((params: any) => {
      const dt = new Date();
      dt.setDate(dt.getDate() + 30);
      if (params['af']) {
        document.cookie = 'naf=' + params['af'] + ';expires=' + dt + ";domain=.nvio.ai;path=/";
        if (params['utm_source']) {
          document.cookie = 'nafref=' + params['utm_source'] + ';expires=' + dt + ";domain=.nvio.ai;path=/";
          // Create payload
          const payload = {
            affiliated_id: params['af'],
            source_ref: params['utm_source'],
            agent: navigator.userAgent,
            referer: document.referrer
          };

          // Send event to server
          if ('sendBeacon' in navigator) {
            navigator.sendBeacon('https://fl.nvio.ai/af', JSON.stringify(payload));
          } else {
            fetch('https://fl.nvio.ai/af', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            }).catch(console.error);
          }
        }
      }
    });

    this.subscriptions.add(
      this.checkForUpdate.appUpdated.subscribe((res: any) => {
        if (res) {
          this.appSvc.dlgsSvc.confirm(
            'Nueva versión disponible',
            'Está disponible una nueva versión de la aplicación ¿Desea cargarla ahora?',
            'Sí, recargar la aplicación',
            'No, lo haré más tarde'
          ).subscribe((res2: any) => {
            if (res2) {
              window.location.reload();
            }
          })
        }
      })
    );
    this.subscriptions.add(
      this.auth.user.subscribe((user: any) => {
        this.user = user;
        if (!this.route.snapshot.queryParams['u']) {
          this.appSvc.getUser(user);
        }
        const token = localStorage.getItem('token');
        if (!token) {
          console.log('🚀 ~ AppComponent ~ this.auth.user.subscribe ~ No token found, redirecting to login');
        }
      })
    );
    this.setTheme();
    this.subscriptions.add(
      this.auth.idToken.subscribe((idToken: any) => {
        this.appSvc.bearerToken = idToken;
      })
    );
    this.subscriptions.add(
      this.dateRangeForm.controls.selectedDays.valueChanges.subscribe((v: any) => {
        this.selectedDays = v;
        console.log('🚀 ~ AppComponent ~ this.dateRangeForm.controls.selectedDays.valueChanges.subscribe ~ this.selectedDays:', this.selectedDays);
        if (this.selectedDays > 0) {
          this.appSvc.updateDateRange(this.selectedDays, false);
        } else {
          this.appSvc.updateDateRange(this.selectedDays);
        }
      })
    );
    this.subscriptions.add(
      this.dateRangeForm.controls.start.valueChanges.subscribe((v: any) => {
        // console.log('🚀 ~ AppComponent ~ this.dateRangeForm.controls.start.valueChanges.subscribe ~ v:', v);
        if (v && v.toISOString) {
          this.dateRange.start = v.toISOString();
        }
      })
    );
    this.subscriptions.add(
      this.dateRangeForm.controls.end.valueChanges.subscribe((v: any) => {
        // console.log('🚀 ~ AppComponent ~ this.dateRangeForm.controls.end.valueChanges.subscribe ~ v:', v);
        if (v && v.toISOString) {
          const offset = (24 * 60 * 60 * 1000);
          v.setTime(v.getTime() + offset);
          this.dateRange.end = v.toISOString();
          this.appSvc.updateDateRange(this.dateRange);
        }
      })
    );
    const selectedDays = localStorage.getItem('selectedDays');
    if (selectedDays) {
      this.dateRangeForm.controls.selectedDays.setValue(parseInt(selectedDays));
    }
    let savedDateRange: any = localStorage.getItem('dateRange');
    if (savedDateRange) {
      savedDateRange = JSON.parse(savedDateRange);
      this.dateRange = savedDateRange;
      this.dateRangeForm.controls.start.setValue(this.dateRange.start);
      this.dateRangeForm.controls.end.setValue(this.dateRange.end);
    }
  }

  ngOnInit(): void {
    this.tourSvc.initialize(this.steps, {
      enableBackdrop: true,
      backdropConfig: {
        offset: 10,
      },
      prevBtnTitle: 'Anterior',
      nextBtnTitle: 'Siguiente',
      stepDimensions: {
        minWidth: '320px',
      }
    });
    this.startInitData();
    this.subscriptions.add(
      this.responsive.observe(
        [
          Breakpoints.Handset,
          Breakpoints.Small,
        ]
      ).subscribe((result: BreakpointState) => {
        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.HandsetPortrait]) {
          this.deviceType = 'handset';
          this.appSvc.deviceType = this.deviceType;
        } else if (breakpoints[Breakpoints.Small]) {
          this.deviceType = 'small';
          this.appSvc.deviceType = this.deviceType;
        } else {
          this.deviceType = 'desktop';
          this.appSvc.deviceType = this.deviceType;
        }
      })
    );
    const days = localStorage.getItem('selectedDays');
    if (days) {
      this.selectedDays = parseInt(days);
    }
  }

  ngAfterContentInit(): void {
  }

  ngAfterViewInit(): void {
    // if (this.tawk) {
    // this.tawk.init({
    //   propertyId: ['656cdaedff45ca7d478673c3'],
    //   widgetId: ['1hgojecji']
    // });
    // }
    // const tawk = new TawkComponent(this.renderer);
    // tawk.ngOnInit();
    // window.Tawk_API = window.Tawk_API || {};
    // this.tawk = window.Tawk_API;
  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
    this.subscriptions.unsubscribeAll();
    this.timeouts.clearAll();
  }

  private calculateTimeToMidnight(): number {

    const now = new Date();
    const midnight = new Date(now);

    midnight.setDate(now.getDate() + 1);
    midnight.setHours(0, 0, 0, 0); // 00:00:00.000

    return midnight.getTime() - now.getTime();

  }

  private clearScheduledTasks(): void {

    if (this.midnightTimeout) {
      clearTimeout(this.midnightTimeout);
      this.midnightTimeout = null;
    }
    if (this.dailyInterval) {
      clearInterval(this.dailyInterval);
      this.dailyInterval = null;
    }

  }

  private executeMidnightLogic(): void {

    if (this.appSvc.selectedDays > 0) {
      this.appSvc.updateDateRange(this.appSvc.selectedDays, false);
    } else {
      this.appSvc.updateDateRange(this.appSvc.selectedDays);
    }
    this.appSvc.onMidnight$.next();

  }

  private scheduleMidnightCheck(): void {

    const delay = this.calculateTimeToMidnight();

    this.clearScheduledTasks();

    this.midnightTimeout = setTimeout(() => {

      this.executeMidnightLogic();

      this.dailyInterval = setInterval(() => {
        this.executeMidnightLogic();
      }, this.MS_PER_DAY);

    }, delay);

  }

  startTour() {
    // this.router.url
    // const routes: any = {
    //   'campaigns': 4
    // };
    let start = 0;
    if (this.router.url.substring(0, 10) == '/campaigns') {
      start = 4;
    } else if (this.router.url.substring(0, 6) == '/lists') {
      start = 7;
    } else if (this.router.url.substring(0, 6) == '/flows') {
      start = 11;
    } else if (this.router.url.substring(0, 9) == '/profiles') {
      start = 14;
    } else if (this.router.url.substring(0, 10) == '/templates') {
      start = 17;
    } else if (this.router.url.substring(0, 7) == '/popups') {
      start = 22;
    } else {
      console.log('🚀 ~ AppComponent ~ startTour ~ this.router.url.substring(0, 9):', this.router.url.substring(0, 9));
    }
    this.tourSvc.startAt(start);
    // this.tourSvc.start();
  }

  startRedisConnection() {
    const channel = 'updates';
    const ws = new WebSocket('wss://us1-pubsub1.upstash.io/pubsub/YOUR_CHANNEL_ID');

    ws.onopen = () => {
      ws.send(JSON.stringify({
        command: 'subscribe',
        channel: channel
      }));
    };

    ws.onmessage = function (event) {
      const data = JSON.parse(event.data);
    };

    ws.onclose = () => console.log('Disconnected');
    ws.onerror = (error) => console.error('WebSocket Error:', error);
  }

  startInitData() {
    this.timeouts.add(
      setTimeout(() => {
        if (this.appSvc.auth && this.appSvc.auth.id && this.appSvc.selectedClient) {
          this.initData();
          this.subscriptions.add(
            this.dataSubscription = this.appSvc.updateData.subscribe((res: any) => {
              this.initData();
            })
          );
        } else {
          setTimeout(() => {
            this.startInitData();
          }, 500);
        }
      }, 100)
    );
  }

  toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }

  async initData() {
    this.clients = this.appSvc.clients;
    this.campaigns = this.appSvc.campaigns;
    this.lists = this.appSvc.lists;
    this.flows = this.appSvc.flows;
    this.profiles = this.appSvc.profiles;
    this.templates = this.appSvc.templates;
    // this.clients = await this.dbSvc.getAllClients();
    // this.campaigns = [];
    // setTimeout(() => {
    //   if (this.clients.length === 0) {
    //     // this.router.navigateByUrl('/clients/new');
    //   }
    // }, 100);
    // this.dbSvc.getSubcollection('clients/' + this.appSvc.selectedClient.id, 'campaigns').then((data: any) => {
    //   data.forEach((campaign: any) => {
    //     this.campaigns.push(campaign.data());
    //   });
    // });
    // this.dbSvc.getSubcollection('clients/' + this.appSvc.selectedClient.id, 'lists').then((data: any) => {
    //   data.forEach((list: any) => {
    //     this.lists.push(list.data());
    //   });
    // });
  }

  setTheme() {
    if (this.theme === 'light') {
      localStorage.setItem('theme', 'light');
      document.body.classList.remove('darkTheme'); // Remove darkMode
      this.isDark = false;
      this.appSvc.isDark = false;
      this.appSvc.updateTheme(this.isDark);
    } else if (this.theme === 'dark') {
      localStorage.setItem('theme', 'dark');
      document.body.classList.add('darkTheme'); // Add darkMode
      this.isDark = true;
      this.appSvc.isDark = true;
      this.appSvc.updateTheme(this.isDark);
    }
  }

  selectedDaysChanged(ev: any) {
    localStorage.setItem('selectedDays', this.selectedDays.toString());
    if (this.selectedDays > 0) {
      this.appSvc.updateDateRange(this.selectedDays, false);
    } else {
      this.appSvc.updateDateRange(this.lastCustomRange ? this.lastCustomRange : this.selectedDays);
    }
  }

  toggleDarkTheme() {
    if (this.theme === 'dark') {
      this.theme = 'light';
      this.setTheme();
      this.isDark = false;
      this.appSvc.updateTheme(this.isDark);
    } else {
      this.theme = 'dark';
      this.setTheme();
      this.isDark = true;
      this.appSvc.updateTheme(this.isDark);
    }
  }

  userSettings() {
    this.router.navigateByUrl('/account');
  }

  openDialog() {
    if (this.appSvc.user && (!this.appSvc.user.user_type || this.appSvc.user.user_type !== 'shopify')) {
      this.lazyDialogSvc.openDialog('client-select').then((dlgRef: any) => {
        this.subscriptions.add(
          dlgRef.afterClosed().subscribe((res: any) => {
            this.appSvc.getUser(this.user);
            this.initData();
          })
        );
      });
    }
  }

  acceptInvitation(notif: any) {
    notif.accepted = true;
    this.dbSvc.storeSubcollection('users/' + this.appSvc.auth.id, 'clients', notif).then((res: any) => {
      this.appSvc.callCF('https://europe-west1-mail-automation-b4f6d.cloudfunctions.net/processInvitation?c=' + this.appSvc.selectedClient.id + '&u=' + this.user.id + "&r=" + notif.role);
      this.appSvc.getUser(this.user);
      this.initData();
      this.dbSvc.delete('invitations', notif.id).then((res: any) => {
        this.drawer.close();
      });
    });
  }

  cancelInvitation(notif: any) {
    notif.accepted = true;
    this.dbSvc.delete('invitations', notif.id).then((res: any) => {
      this.appSvc.getUser(this.user);
      this.initData();
      this.drawer.close();
    });
  }

  showHelp() {
    // this.tawk.popup();
    // this.tawk.toggle();
    if (!this.appSvc.tawkInitiated) {
      this.appSvc.initTawk();
      window.Tawk_API = window.Tawk_API || {};
      this.tawk = window.Tawk_API;
    } else {
      this.tawk.toggle();
    }
  }

  toggleBlur() {
    document.body.classList.toggle('hideData');
    this.blurred = !this.blurred;
  }

}
